import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useCancelImage() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const cancelImage = useCallback(
    (uploadedImageId, setUploadedImageId) => {
      if (uploadedImageId) {
        setUploadedImageId(null);
        fetchWrapper({
          endpoint_url: "image/cancelImage",
          params: {
            image_id: uploadedImageId,
          },
          onSuccess: (fetch_output) => {
            if ("error" in fetch_output) {
              showMessage({ message: fetch_output.error });
            }
          },
          onFetchError: () =>
            showMessage({ apiType: "fetch", message: "Cancel Image" }),
          onResponseError: () =>
            showMessage({ apiType: "response", message: "Cancel Image" }),
        });
      }
    },
    [fetchWrapper]
  );

  return { cancelImage };
}

export default useCancelImage;
